import chalk from 'chalk';

export class Spinner {
  private frames = ['⠋', '⠙', '⠹', '⠸', '⠼', '⠴', '⠦', '⠧', '⠇', '⠏'];
  private interval: NodeJS.Timeout | null = null;
  private currentFrame = 0;
  private message: string;

  constructor(message: string) {
    this.message = message;
  }

  start() {
    process.stdout.write('\x1B[?25l'); // Hide cursor
    this.interval = setInterval(() => {
      process.stdout.write('\r' + chalk.cyan(this.frames[this.currentFrame]) + ' ' + this.message);
      this.currentFrame = (this.currentFrame + 1) % this.frames.length;
    }, 100);
  }

  stop(finalMessage?: string) {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
    process.stdout.write('\r' + ' '.repeat(this.message.length + 2) + '\r'); // Clear line
    process.stdout.write('\x1B[?25h'); // Show cursor
    if (finalMessage) {
      console.log(finalMessage);
    }
  }
}